import React, { useState } from 'react';
import { object } from 'prop-types';

import '../styles/ChildCategories.css';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

function ChildCategories ({ hierarchy }) {
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const current = hierarchy.default?.filter((category) => category.LEVEL === 2);
    const [showAll, setShowAll] = useState(false);

    const ITEMS_TO_SHOW = 12; // Number of categories to show initially

    if (!current?.length) {
        return null;
    }

    const sortedCategories = current.sort((a, b) => a.title.localeCompare(b.title));
    const displayCategories = showAll ? sortedCategories : sortedCategories.slice(0, ITEMS_TO_SHOW);

    return (
        <div
            className={'child-categories--wrapper'}
        >
            <div
                className={'child-categories--grid'}
            >
                {displayCategories.map(({ id, title, handle }) => (
                    <div
                        className={'child-categories--item'}
                        key={id}
                    >
                        <span
                            className={'child-categories--arrow'}
                        >
                            {'>'}
                        </span>
                        <Link
                            className={'custom-link'}
                            to={`${collectionPath[0].pathBeforeParams}/${handle}`}
                        >
                            {title}
                        </Link>
                    </div>
                ))}
            </div>

            {sortedCategories.length > ITEMS_TO_SHOW && (
                <div
                    className={'child-categories--show-more-container'}
                >
                    <button
                        className={'child-categories--show-more-button'}
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? 'Show Less Categories' : 'Show More Categories'}
                    </button>
                </div>
            )}
        </div>
    );
}

ChildCategories.propTypes = {
    hierarchy: object,
};

export default ChildCategories;